import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import {
    PropertyAgentContactDetailsData,
    PropertyAgentContactDetailsType
} from '../../../models/property-agent-contact-details/property-agent-contact-details-model';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-agent-contact-details-section',
    templateUrl: './summary-page-agent-contact-details-section.component.html',
    styleUrls: ['./summary-page-agent-contact-details-section.component.scss']
})
export class SummaryPageAgentContactDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    values: Record<PropertyAgentContactDetailsType, PropertyAgentContactDetailsData> = {
        [PropertyAgentContactDetailsType.primary]: {
            name: null,
            mobile: null,
            landLine: null,
            email: null,
            brandingImageId: null,
            photoUrl: null,
            isPhotoRemovalDisabled: null
        },
        [PropertyAgentContactDetailsType.secondary]: {
            name: null,
            mobile: null,
            landLine: null,
            email: null,
            brandingImageId: null,
            photoUrl: null,
            isPhotoRemovalDisabled: null
        }
    };

    isSecondContactDetailAdded = false;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            const {
                name,
                mobile,
                landLine,
                email,
                brandingImageId,
                photoUrl,
                isPhotoRemovalDisabled,
                secondName,
                secondMobile,
                secondLandLine,
                secondEmail,
                secondBrandingImageId,
                secondPhotoUrl,
                secondIsPhotoRemovalDisabled
            } = this.draftData.propertyInformation;

            if (name) {
                this.values[PropertyAgentContactDetailsType.primary] = {
                    name,
                    mobile,
                    landLine,
                    email,
                    brandingImageId,
                    photoUrl,
                    isPhotoRemovalDisabled
                };
            }

            if (secondName) {
                this.values[PropertyAgentContactDetailsType.secondary] = {
                    name: secondName,
                    mobile: secondMobile,
                    landLine: secondLandLine,
                    email: secondEmail,
                    brandingImageId: secondBrandingImageId,
                    photoUrl: secondPhotoUrl,
                    isPhotoRemovalDisabled: secondIsPhotoRemovalDisabled
                };

                this.isSecondContactDetailAdded = true;
            }

            this._changeDetectorRef.markForCheck();
        });
    }

    get propertyAgentContactDetailsType(): typeof PropertyAgentContactDetailsType {
        return PropertyAgentContactDetailsType;
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
